import React from "react";
import Footer from "./Footer";
import { Link, NavLink, Outlet } from "react-router-dom";
function Header() {
  return (
    <div>
      <header className="header-area">
        <div className="container c-fulid-max">
          <div className="row">
            <div className="col-4 col-md-4">
              <div className="logo-wrapper logo-designn">MAC PRINCE</div>
            </div>
            <div className="col-8 col-md-8">
              <div className="menu-wrapper">
                <nav className="main-nav">
                  <input id="main-menu-state" type="checkbox" />
                  <label className="main-menu-btn" htmlFor="main-menu-state">
                    <span className="main-menu-btn-icon" />
                  </label>
                  <ul id="main-menu" className="sm sm-mint">
                    <li>
                      <a href="#home" className="smoothscroller">
                        Home
                      </a>
                    </li>
                    <li>
                      <a href="#about" className="smoothscroller">
                        About
                      </a>
                    </li>
                    <li>
                      <a href="#service" className="smoothscroller">
                        Service
                      </a>
                    </li>
                    <li>
                      <a href="#portfolio" className="smoothscroller">
                        Portfolio
                      </a>
                    </li>
                    <li>
                      <a href="#blog" className="smoothscroller">
                        Courses
                      </a>
                    </li>
                    <li>
                      <a href="#contact" className="smoothscroll">
                        Contact
                      </a>
                    </li>
                  </ul>
                </nav>
                <div className="header-btn">
                  <a
                    href="https://wa.me/2349056789309"
                    className="btn-chat btn-h"
                  >
                    <span>Let’s Chat</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Outlet />
      <Footer />
    </div>
  );
}

export default Header;
